// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QN9Y","label":"styles_label__2wpQv"};